export const CLIENT_CREATE_QUERY_KEY = 'client-create-info';
export const CLIENT_CREATE_DOCUMENTS_QUERY_KEY = 'client-create-documents';
export const CLIENT_CREATE_RELATED_PASSENGERS_QUERY_KEY = 'client-create-related-passengers';
export const CLIENT_CREATE_PREFERENCES_QUERY_KEY = 'client-create-preferences';
export const RELATED_TRAVELERS_QUERY_KEY = 'related-travelers';
